import { useCallback, useMemo } from 'react'

export const useScrollToRefs = (names) => {
  const refs = useMemo(() => {
    const newRefs = {}
    names.forEach((name) => {
      newRefs[name] = { current: null }
    })
    return newRefs
  }, [names]) // names is the dependency

  const scrollToNamedRef = useCallback((name) => {
    if (!refs[name]?.current) return undefined
    refs[name]?.current?.scrollIntoView({ behavior: 'smooth' })
  }, [refs])

  return [refs, scrollToNamedRef]
}

export const useScrollToRef = (name) => {
  const [refs, scrollToNamedRef] = useScrollToRefs([name])
  const ref = refs[name]
  const scrollToRef = useCallback(() => scrollToNamedRef(name), [scrollToNamedRef, name])

  return [ref, scrollToRef]
}
